<template>
  <div v-if="hasPermission(menu.index)">
    <el-menu-item v-if="menu.children == null || menu.children.length == 0" :key="menu.index" :index="menu.index">
      <span v-if="menu.src === '1'">
        <img src="../../../static/lq.png" alt="icon" class="menu-icon" />
      </span>
      <span v-if="menu.src === '2'">
        <img src="../../../static/lq2.png" alt="icon" class="menu-icon" />
      </span>
<!--      <i :class="menu.icon"></i>-->
      <span slot="title">{{menu.label}}</span>
    </el-menu-item>
    <el-submenu v-else :index="menu.index">
      <template slot="title">
<!--        <i :class="menu.icon"></i>-->
        <span v-if="menu.src === '1'">
          <img src="../../../static/lq.png" alt="icon" class="menu-icon" />
        </span>
          <span v-if="menu.src === '2'">
          <img src="../../../static/lq2.png" alt="icon" class="menu-icon" />
        </span>
        <span slot="title">{{menu.label}}</span>
      </template>
      <MenuItems v-for="child in menu.children" :menu="child" :key="child.index"/>
    </el-submenu>
  </div>
</template>

<script>
export default {
  name: 'MenuItems',
  props: {
    menu: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/MenuItems.vue